import { deepFreeze } from 'utils/deepFreeze';
import type { MoreOfWhatYouLoveState } from '../types';

export const initialState: Readonly<MoreOfWhatYouLoveState> = deepFreeze({});
